<span class="label">{{label}}</span>
<div class="value">
  <ng-content></ng-content>
</div>
